import { FeedbotThunk } from '../../../store/types'
import { featureValueSelector } from '../../../store/features/selectors'
import { feedbotToast } from '../../../lib/feedbotToast'
import { promptForBotNameAndId } from '../../../lib/prompt'
import { modalsActions } from '../../../store/modals/modalsSlice'
import { endpointHelpers } from '../endpointHelpers'
import { switchBot } from '../../../lib/navigation'

export const initiateBotCreationProcess = (): FeedbotThunk => (dispatch, getState) => {
  const generatedNameMode = featureValueSelector('GENERATE_BOT_NAME')(getState())

  if (!generatedNameMode) {
    dispatch(initiateLegacyBotCreation())
    return
  }

  dispatch(
    modalsActions.openModal({
      type: 'create_bot_settings',
      openSection: 'form',
      creationType: 'create_new'
    })
  )
}

function initiateLegacyBotCreation(promptTitle: string = 'Enter bot name'): FeedbotThunk {
  return async (dispatch, getState) => {
    const queryResult = await endpointHelpers.getBotsMetadata.initiate()(dispatch, getState)

    if (!queryResult.data) {
      return feedbotToast.error({ title: 'Failed to initiate bot creation process', content: '' })
    }

    const nameAndId = await promptForBotNameAndId(
      queryResult.data,
      { allowReserved: false, allowCurrent: false, allowExisting: false },
      promptTitle
    )

    if (nameAndId === null) {
      return
    }

    await dispatch(
      endpointHelpers.createNewBot.initiate({
        id: nameAndId.id,
        categorization: { name: nameAndId.name }
      })
    )

    switchBot(nameAndId.id)
  }
}
